import React from 'react'
import { useState } from 'react'
import { ADD_ENERGY } from '../helpers/api'

function EnergyForm() {




    return (
        <>
            <section className='become-seller_sec'>
                <div className="container">
                    <div className="card jc-center">
                        <h3>Add Energy hello</h3>
                        <form>
                            <div className="mb-3">
                                <label className="bg-dark form-label mb-2">Price</label>
                                <input type="Number" className="form-control" placeholder='Enter here' />
                            </div>
                            <div className="mb-3">
                                <label className="form-label mb-2">Energy (kwh)</label>
                                <input type="text" className="form-control" placeholder='Enter here' />
                            </div>
                            <div className='mb-5'>
                                <label className="form-check-label mb-2">Is Green?</label>
                                <select className="form-select form-control" aria-label="Default select example">
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                            </div>

                            <button className="btn confirm_btn">Submit</button>
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}

export default EnergyForm
